import React from 'react';
import Icon from 'components/lib/icons/icon';

export default props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <circle cx="8" cy="8" r="8" />
    <path d="M6 7a1 1 0 100-2 1 1 0 000 2zM10 7a1 1 0 100-2 1 1 0 000 2z" fill="white" />
    <path d="M4.5 9.5c1 1.51 3.8 3.622 7 0" fill="none" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/emoji_picker_icon.jsx